import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSpk } from "../../../../../Redux/reducer/env";
import IconContinue from "../../../../../../static/images/icon-continue.svg";
import Arrow from "../../../../../../static/images/arrow.svg";

export class StepControl extends Component {
  render() {
    return (
      <div className="controls">
        {this.props.currentStep > 1 && (
          <div
            className={
              this.props.spk !== undefined &&
              this.props.spk !== "" &&
              (window.location.pathname !== "/user/reset-password"
                ? "go-back"
                : "go-back no-button")
            }
            onClick={this.props.goBack}
          >
            <img src={Arrow} alt="Atrás" /> Volver
          </div>
        )}
        <button type="submit" className="submit-form ml-auto" onClick={this.props.submitStep}>
          Continuar <img src={IconContinue} alt={`Continue`} />
        </button>
      </div>
    );
  }
}

StepControl.propTypes = {
  currentStep: PropTypes.number.isRequired,
  submitStep: PropTypes.func.isRequired,
  goBack: PropTypes.func,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(StepControl);
